const Amplitude = require('./dist').default

module.exports = Amplitude
module.exports.default = module.exports
